import { useRef, useState } from "react";
import { useSoundPath } from "hooks/useSoundPath";
import useEffectOnce from "hooks/useEffectOnce";
import PagePopopCloseButton from "components/page-components/PagePopopCloseButton";
import useProfile from "hooks/useProfile";
import ModalWindow from "components/ModalWindow";

const OpenPackVideo = ({isVideoVisible, setIsVideoVisible, animation, isMobile }) => {
  const videoRef = useRef(null);
  const playSound = useSoundPath();
  const {flags} = useProfile();
  const isSoundOn = flags.sound;


  const close = () => {
    playSound('main');
    setIsVideoVisible(false)
  };

  useEffectOnce(() => {
    const videoElement = videoRef.current;

    if (videoElement) {
      videoElement.volume = 0.4;
      videoElement.addEventListener('ended', () => {
        setIsVideoVisible(false);
      });
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener('ended', () => {
          setIsVideoVisible(false);
        });
      }
    };
  });

  if (isVideoVisible) {
    return (
      <ModalWindow
        additionalClass="modal-window--animation"
        close={close}
      >
        <div className="modal-window__wrapper modal-window__wrapper--animation" onClick={(e) => e.stopPropagation()}>
          <PagePopopCloseButton close={close} />
          <video src={animation.web} ref={videoRef} preload autoPlay playsInline muted={!isSoundOn} />
        </div>
      </ModalWindow>
    )
  } else return null;
}

export default OpenPackVideo;
